import { FeedsMainContainer } from '@/modules/Feeds';

const Feeds = (): JSX.Element => <FeedsMainContainer />;

export default Feeds;
